import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExibeMenuService {
  private exibeMenuSource = new BehaviorSubject<boolean>(true); // Começa como true (exibido)
  exibeMenu$ = this.exibeMenuSource.asObservable();

  toggleMenu(exibe: boolean): void {
    this.exibeMenuSource.next(exibe);
  }
}
